import http from './ApiConfig';
import { Service } from './Service';

export class ConvenioService extends Service {
  constructor() {
    super('convenios');
  }

  public GetAllPaginado(limit: number, page: number, nome: string) {
    return http.get(`${this._nomeControle}?limit=${limit}&page=${page}&nome=${nome}`, this.GetHeader());
  }

  public getAllSelect() {
    return http.get(`${this._nomeControle}/lista-convenios`, this.GetHeader());
  }

  public Inativar(id: number) {
    return http.patch(`${this._nomeControle}/${id}/inativar`, {}, this.GetHeader());
  }

  public Ativar(id: number) {
    return http.patch(`${this._nomeControle}/${id}/ativar`, {}, this.GetHeader());
  }
}
